import { AppBar, Box, Link, Toolbar, Typography, Button } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import CasinoIcon from "@mui/icons-material/Casino";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import LoginIcon from "@mui/icons-material/Login";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import { useLocation, useNavigate } from "react-router-dom";
import { useFakeToken } from "../../hooks/useFakeToken";

const navItemsList = [
  { path: "/", label: "Αρχικη", icon: <HomeIcon />, privateUrl: false },
  {
    path: "/lotteries",
    label: "Λοταριες",
    icon: <CasinoIcon />,
    privateUrl: true,
  },
  {
    path: "/prizes",
    label: "Δωρα",
    icon: <CardGiftcardIcon />,
    privateUrl: true,
  },
  {
    path: "/run",
    label: "Τρεξιμο Λοταρίας",
    icon: <PlayCircleIcon />,
    privateUrl: true,
  },
];

export const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loggedIn, removeToken } = useFakeToken();

  const navItems = loggedIn
    ? navItemsList
    : navItemsList.filter((x) => !x.privateUrl);

  const logout = () => {
    removeToken();
    navigate("/");
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background:
            "linear-gradient(135deg, hsl(150, 60%, 25%) 0%, hsl(150, 70%, 18%) 100%)",
          boxShadow: "0 4px 20px -4px rgba(22, 91, 51, 0.4)",
        }}
      >
        <Toolbar>
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 1, flexGrow: 1 }}
          >
            <AcUnitIcon className="animate-sparkle" />
            <Typography
              variant="h5"
              component={Link}
              sx={{
                fontFamily: '"Mountains of Christmas", cursive',
                color: "white",
                textDecoration: "none",
                fontWeight: 700,
              }}
            >
              Christmas Lottery
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            {navItems.map((item) => (
              <Button
                key={item.path}
                component={Link}
                onClick={() => navigate(item.path)}
                startIcon={item.icon}
                sx={{
                  color: "white",
                  bgcolor:
                    location.pathname === item.path
                      ? "rgba(255,255,255,0.15)"
                      : "transparent",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.25)" },
                  borderRadius: 2,
                  px: 2,
                }}
              >
                {item.label}
              </Button>
            ))}
            {!loggedIn && (
              <Button
                key={"loginkey"}
                component={Link}
                onClick={() => navigate("login")}
                startIcon={<LoginIcon />}
                sx={{
                  color: "white",
                  bgcolor: "transparent",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.25)" },
                  borderRadius: 2,
                  px: 2,
                }}
              >
                {"Συνδεση"}
              </Button>
            )}
            {loggedIn && (
              <Button
                key={"logoutkey"}
                component={Link}
                onClick={logout}
                startIcon={<LoginIcon />}
                sx={{
                  color: "white",
                  bgcolor: "transparent",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.25)" },
                  borderRadius: 2,
                  px: 2,
                }}
              >
                {"αποσυνδεση"}
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
};
